import * as React from 'react';
import { inject } from 'mobx-react';
import { GcDefaultHeader } from '../gc-default-header';
import { usePlatformContext } from '@bernie/platform-context';
export var BEXHeader = inject('globalComponentsContext', 'analytics', 'page')(function (_a) {
  var globalComponentsContext = _a.globalComponentsContext,
    analytics = _a.analytics,
    page = _a.page,
    minimal = _a.minimal,
    simplified = _a.simplified,
    fullWidth = _a.fullWidth;
  var context = usePlatformContext().context;
  var _b = globalComponentsContext.header,
    l10n = _b.l10n,
    logoUrl = _b.logoUrl,
    cobrandPosition = _b.cobrandPosition;
  return React.createElement(GcDefaultHeader, {
    context: context,
    globalComponentsContext: globalComponentsContext,
    analytics: analytics,
    page: page,
    l10n: l10n,
    logoUrl: logoUrl,
    minimal: minimal,
    simplified: simplified,
    cobrandPosition: cobrandPosition,
    fullWidth: fullWidth
  });
});